import * as O from "fp-ts/Option"

/** Le chemin courant est-il celui du lien, ou une page sous ce lien ? */
export function pathMatchesLink(pathname: string, href: string): boolean {
  return pathname === href || pathname.startsWith(href + "/")
}

/**
 * Lien actif d'un groupe de la barre latérale : le plus précis de ceux qui
 * couvrent le chemin courant. Sur `/documents/generate`, « Générer »
 * (`/documents/generate`) l'emporte sur « Tous les documents » (`/documents`),
 * qui couvre aussi ce chemin : un seul lien du groupe est surligné.
 */
export function activeSidebarLink(pathname: string, hrefs: ReadonlyArray<string>): O.Option<string> {
  return hrefs
    .filter((href) => pathMatchesLink(pathname, href))
    .reduce<O.Option<string>>(
      (best, href) => (O.isSome(best) && best.value.length >= href.length ? best : O.some(href)),
      O.none,
    )
}
